a.reservation.edit_single = (function(){
	var my = {
		popup:function(o){
			var rid = o.rid || undefined;
			var f_close = o.close || function(){};
			var token = a.popup.create({
				slideFrom:'fromleft',
				title:'Edit reservation',
				winbar_action_icon:'trash',
				winbar_action:function(){
					my.loadRecord(token,rid,function(result){
						if (result.res.is_part_of_recurring) {
							a.prompt.create({
								'question':'The reservation is part of a recurring series, however this will only delete this reservation. Proceed?',
								'answers':[{
									'value':'Yes, delete single reservation',
									'action':function(){
										my.deleteSingle(result.res.rid,function(){
											window.history.back();
										});
									}
								}]
							});
							/*a.prompt.create({
								'question':'The reservation is part of a recurring series. What would you like to delete?',
								'answers':[{
									'value':'The entire series',
									'action':function(){
										my.deleteSeries(result.res.rdid,function(){
											window.history.back();
										});
									}
								},{
									'value':'Just this reservation',
									'action':function(){
										my.deleteSingle(result.res.rid,function(){
											window.history.back();
										});
									}
								}]
							});*/
						}
						else {
							a.prompt.create({
								'question':'This will permanently delete the reservation. Proceed?',
								'answers':[{
									'value':'Yes, delete reservation',
									'action':function(){
										my.deleteSingle(result.res.rid,function(){
											window.history.back();
										});
									}
								}]
							});
						}
					});
				},
				css_class:'',
				ready:function(token){
					// Load record
					my.loadRecord(token,rid,function(result){
						if (result.success) {
							tpl.run({
								tpl:'/tpl/reservation/edit_single/popup.ejs?v='+v,
								data:result.res,
								cb:function(c){
									$('#popupid_'+token+'>.ic').empty().append(c).ready(function(){
										my.init(result,token,rid,f_close);
									});
								}
							});
						}
						else {
							a.s.growl.create('Error','Unable to perform operation',{});
						}
					});
				}
			});
		},
		init:function(result,token,rid,f_close){
			var win = $('#popupid_'+token);
			var form = $('#popupid_'+token+' form');
			// Avoid buttons to be activated by enter
			/*form.on('keyup keypress', function(e) {
				var keyCode = e.keyCode || e.which;
				if (keyCode === 13) { 
					e.preventDefault();
					return false;
				}
			});*/
			// Bind name change
			$('input[name="name"]',form).unbind('keyup').on('keyup',function(){
				my.validateForm(token);
			});
			// Init item picker element
			var ipe = a.s.itempickerelement();
			// Insert time date range picker
			var dtrp = a.s.datetimerangepicker();
			var dtrp_start_date = new Date();
			dtrp.el = $('[data-area="datetimerangepicker"]');
			dtrp.timeformat = a.userinfo.timeformat;
			dtrp.calendar_width = 740;
			dtrp.start_datetime = new Date(result.res.time_start);
			dtrp.end_datetime = new Date(result.res.time_end);
			dtrp.change = function () {
				if (dtrp.valid_output) {
					$('input[name="start"]',form).val(dtrp.output_start);
					$('input[name="end"]',form).val(dtrp.output_end);
					my.getFilterWithResDates(function(filter){
						ipe.filter = filter;
						ipe.reloadItemList();
					},result.res.rid,win);
				}
				else {
					$('input[name="start"]',form).val('');
					$('input[name="end"]',form).val('');
				}
				my.validateForm(token);
			}
			dtrp.ready = function () {
				// Insert item list picker element
				ipe.el = $('div[data-area="itemlistpicker"]',form);
				ipe.filter = {};
				if (result.res.itemlist && result.res.itemlist.length>0) {
					var iid_list = result.res.itemlist.map(function(e){
						return e.iid;
					});
					ipe.iid_list = iid_list;
					my.getFilterWithResDates(function(filter){
						ipe.filter = filter;
						ipe.insert();
					},result.res.rid,win);
				}
				ipe.change = function(){
					my.validateForm(token);
				}
			}
			dtrp.insert();
			// Insert obo picker element
			a.s.pickerelement.insert({
				el: $('div[data-area="obopicker"]',form),
				type: 'user',
				inputname: 'obo',
				undefined_text: 'Select user',
				value:result.res.user_obo.fullname,
				id:result.res.user_obo.uid
			});
			// Insert location picker element
			a.s.pickerelement.insert({
				el: $('div[data-area="locationpicker"]',form),
				type: 'location',
				inputname: 'location',
				value:(result.res.location)?result.res.location.name:undefined,
				id:(result.res.location)?result.res.location.id:undefined
			});
			// Save
			$('button[data-action="save-reservation"]',win).unbind('click').click(function(){
				my.save(token,rid,result,f_close);
			});
			// Granular gating: an 'own'-scoped user who didn't create this reservation (and
			// isn't the on-behalf-of user) can't edit or delete it — hide the affordances.
			if (!a.s.ac.can('actions','reservation',{made_by:(result.res.made_by||{}).uid,assigned_to:[(result.res.user_obo||{}).uid]})) {
				$('.popupwinbar>.action>i',win).hide();
				$('button[data-action="save-reservation"]',win).hide();
			}
		},
		loadRecord:function(token,rid,result_cb){
			$.ajax({
				type:'GET',
				url:'/api/reservation/load/',
				data:{
					rid:rid,
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					result_cb(result);
				}
			});
		},
		getFilterWithResDates:function(cb,rid,win) {
			var filter = {
				'res_period':[],
				'ignore_reservation_id':rid
			};
			if ($('input[name="start"]',win).val().length>10 && $('input[name="end"]',win).val().length>10) {
				filter.res_period.push($('input[name="start"]',win).val().replace(' ','T')+';'+$('input[name="end"]',win).val().replace(' ','T'));
			}
			cb(filter);
		},
		save:function(token,rid,result,f_close){
			var form = $('#popupid_'+token+' form');
			var data = form.serializeJSON();
			data.token = localStorage.getItem('token');
			data.accountname = localStorage.getItem('accountname');
			a.loader.fs.create();
			$.ajax({
				type:'POST',
				url:'/api/reservation/save/single/',
				data:data,
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						a.s.growl.create('Success','Reservation changes was saved',{});
						window.history.back();
						f_close();
					}
					else {
						if (result.errorlist) {
							result.errorlist.forEach(function(e){
								a.s.growl.create('Error',e.message,{});
							});
						}
						else {
							a.s.growl.create('Error','Unable to save reservation changes',{});
						}
					}
				}
			}).done(function(){
				a.loader.fs.remove();
			});
		},
		validateForm:function(token){
			var form = $('#popupid_'+token+' form');
			var valid = true;
			if ($('input[name="name"]',form).val().trim().length<3) {
				valid = false;
			}
			if ($('input[name="iid[]"]',form).length==0) {
				valid = false;
			}
			if ($('input[name="start"]',form).val().length<3 || $('input[name="end"]',form).val().length<3) {
				valid = false;
			}
			if (valid) {
				$('button[data-action="save-reservation"]',form).prop('disabled',false);
			}
			else {
				$('button[data-action="save-reservation"]',form).prop('disabled',true);
			}
		},
		deleteSingle:function(rid,cb_delete){
			$.ajax({
				type:'POST',
				url:'/api/reservation/delete/',
				data:{
					rid:rid,
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						cb_delete();
						a.s.growl.create('Success','Reservation was deleted',{});
					}
					else {
						a.s.growl.create('Error','Unable to delete reservation',{});
					}
				}
			});
		}
	}
	return my;
}());